// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rd-section {
  --rd-brand: #1e56f5;
  --rd-success: #5eba89;
  --rd-surface: #fff;
  --rd-muted: #6c757d;
  --rd-border: #eef0f4;
  --rd-text: rgba(0, 0, 0, 0.78);
  --rd-shadow: 0 8px 28px rgba(30, 86, 245, 0.06);
  --rd-radius: 16px;
}

.rd-section .rd-banner {
  margin-bottom: 22px;
}

.rd-section .rd-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 14px;
  margin: 0 0 18px;
}

.rd-section .rd-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.rd-section .rd-chip {
  border: 1px solid #e2e4e8;
  background: var(--rd-surface);
  color: inherit;
  border-radius: 50px;
  padding: 6px 14px;
  font-size: 13px;
  cursor: pointer;
  transition: 0.2s ease;
}

.rd-section .rd-chip:hover {
  border-color: rgba(30, 86, 245, 0.4);
}

.rd-section .rd-chip.active {
  background: var(--rd-brand);
  border-color: var(--rd-brand);
  color: #fff;
}

.rd-section .rd-search {
  min-width: 220px;
  flex: 1 1;
}

.rd-section .rd-row-click {
  cursor: pointer;
}

.rd-section .rd-row-click:hover {
  background: rgba(30, 86, 245, 0.06);
}

.rd-section .rd-pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px 0 4px;
}

.rd-section .rd-stat-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  margin-bottom: 22px;
}

.rd-section .rd-stat-grid--levels {
  grid-template-columns: repeat(6, 1fr);
}

.rd-section .rd-stat-card {
  background: var(--rd-surface);
  border: 1px solid var(--rd-border);
  border-radius: var(--rd-radius);
  padding: 18px 20px;
  box-shadow: var(--rd-shadow);
  min-width: 0;
  position: relative;
  overflow: hidden;
}

.rd-section .rd-stat-card::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--rd-brand), #6b5ce7);
  opacity: 0.55;
}

.rd-section .rd-stat-card--earn::after {
  background: linear-gradient(90deg, var(--rd-success), #4a9e6f);
}

.rd-section .rd-stat-card__label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--rd-muted);
  font-weight: 600;
  margin-bottom: 8px;
}

.rd-section .rd-stat-card__value {
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
  color: var(--rd-text);
  word-break: break-word;
}

.rd-section .rd-stat-card--earn .rd-stat-card__value {
  color: var(--rd-success);
}

.rd-section .rd-stat-card__hint {
  font-size: 12px;
  color: #8b939e;
  margin-top: 6px;
}

.rd-section .rd-profile {
  display: flex;
  align-items: center;
  gap: 16px;
  background: var(--rd-surface);
  border: 1px solid var(--rd-border);
  border-radius: var(--rd-radius);
  padding: 16px 18px;
  box-shadow: var(--rd-shadow);
  margin-bottom: 18px;
}

.rd-section .rd-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--rd-brand), #6b5ce7);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  letter-spacing: 0.04em;
  flex-shrink: 0;
}

.rd-section .rd-profile__name {
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 6px;
  color: var(--rd-text);
}

.rd-section .rd-profile__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  color: var(--rd-muted);
  font-size: 13px;
}

.rd-section .rd-back {
  border-radius: 50px !important;
  padding: 6px 16px !important;
  white-space: nowrap;
}

.rd-section .rd-panel {
  background: var(--rd-surface);
  border: 1px solid var(--rd-border);
  border-radius: var(--rd-radius);
  box-shadow: var(--rd-shadow);
  overflow: hidden;
  margin-bottom: 12px;
}

.rd-section .rd-inner-tabs {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  padding: 8px 16px 0;
  border-bottom: 1px solid var(--rd-border);
  background: #f8f9fb;
}

.rd-section .rd-inner-tab {
  border: 0;
  background: transparent;
  padding: 12px 14px;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  color: var(--rd-muted);
  font-size: 14px;
}

.rd-section .rd-inner-tab.active {
  border-bottom-color: var(--rd-brand);
  color: var(--rd-brand);
  font-weight: 600;
}

.rd-section .rd-tab-count {
  display: inline-flex;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  margin-left: 6px;
  border-radius: 50px;
  background: rgba(30, 86, 245, 0.1);
  color: var(--rd-brand);
  font-size: 11px;
  font-weight: 700;
  align-items: center;
  justify-content: center;
}

.rd-section .rd-panel-body {
  padding: 18px 20px 22px;
  min-height: 220px;
}

.rd-section .rd-empty {
  text-align: center;
  padding: 36px 16px;
  color: var(--rd-muted);
}

.rd-section .rd-empty p {
  margin: 12px 0 0;
}

.rd-section .rd-package-card {
  border: 1px solid var(--rd-border);
  border-radius: 14px;
  padding: 16px;
  margin-bottom: 12px;
  background: #fbfcfe;
}

.rd-section .rd-package-head {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}

.rd-section .rd-kv {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 16px;
  font-size: 13px;
}

.rd-section .rd-kv span {
  color: var(--rd-muted);
  display: block;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 2px;
}

.rd-section .rd-badge {
  display: inline-block;
  padding: 3px 9px;
  border-radius: 50px;
  font-size: 12px;
  font-weight: 600;
  background: rgba(30, 86, 245, 0.1);
  color: var(--rd-brand);
}

.rd-section .rd-badge.buy {
  background: rgba(94, 186, 137, 0.16);
  color: var(--rd-success);
}

.rd-section .rd-badge.sell {
  background: rgba(220, 53, 69, 0.12);
  color: #dc3545;
}

.rd-section .rd-table-wrap {
  overflow-x: auto;
}

.rd-section .rd-table-wrap table {
  width: 100%;
}

.rd-section .rd-table-wrap table th {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--rd-muted);
  border-bottom: 1px solid var(--rd-border);
  padding: 10px 8px;
  font-weight: 600;
}

.rd-section .rd-table-wrap table td {
  padding: 12px 8px;
  border-bottom: 1px solid var(--rd-border);
  font-size: 13px;
  vertical-align: middle;
}

body:not(.light_theme) .rd-section,
body.dark_theme .rd-section {
  --rd-surface: #1e242c;
  --rd-border: rgba(255, 255, 255, 0.1);
  --rd-text: #f2f4f6;
  --rd-muted: #949aa4;
  --rd-shadow: 0 8px 28px rgba(0, 0, 0, 0.2);
}

body:not(.light_theme) .rd-section .rd-chip,
body.dark_theme .rd-section .rd-chip {
  background: transparent;
  border-color: rgba(255, 255, 255, 0.15);
}

body:not(.light_theme) .rd-section .rd-chip.active,
body.dark_theme .rd-section .rd-chip.active {
  background: var(--rd-brand);
  border-color: var(--rd-brand);
}

body:not(.light_theme) .rd-section .rd-inner-tabs,
body.dark_theme .rd-section .rd-inner-tabs {
  background: rgba(255, 255, 255, 0.03);
}

body:not(.light_theme) .rd-section .rd-package-card,
body.dark_theme .rd-section .rd-package-card {
  background: rgba(255, 255, 255, 0.03);
}

@media (max-width: 1100px) {
  .rd-section .rd-stat-grid--levels {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 767px) {
  .rd-section .rd-stat-grid,
  .rd-section .rd-stat-grid--levels,
  .rd-section .rd-kv {
    grid-template-columns: 1fr;
  }

  .rd-section .rd-profile {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/customComponents/ReferralDetailsSection/referralDetails.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;EAC9B,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,aAAa;AACf;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;;EAEE,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;;EAEE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".rd-section {\n  --rd-brand: #1e56f5;\n  --rd-success: #5eba89;\n  --rd-surface: #fff;\n  --rd-muted: #6c757d;\n  --rd-border: #eef0f4;\n  --rd-text: rgba(0, 0, 0, 0.78);\n  --rd-shadow: 0 8px 28px rgba(30, 86, 245, 0.06);\n  --rd-radius: 16px;\n}\n\n.rd-section .rd-banner {\n  margin-bottom: 22px;\n}\n\n.rd-section .rd-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px 14px;\n  margin: 0 0 18px;\n}\n\n.rd-section .rd-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.rd-section .rd-chip {\n  border: 1px solid #e2e4e8;\n  background: var(--rd-surface);\n  color: inherit;\n  border-radius: 50px;\n  padding: 6px 14px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n\n.rd-section .rd-chip:hover {\n  border-color: rgba(30, 86, 245, 0.4);\n}\n\n.rd-section .rd-chip.active {\n  background: var(--rd-brand);\n  border-color: var(--rd-brand);\n  color: #fff;\n}\n\n.rd-section .rd-search {\n  min-width: 220px;\n  flex: 1;\n}\n\n.rd-section .rd-row-click {\n  cursor: pointer;\n}\n\n.rd-section .rd-row-click:hover {\n  background: rgba(30, 86, 245, 0.06);\n}\n\n.rd-section .rd-pager {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 16px 0 4px;\n}\n\n.rd-section .rd-stat-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 14px;\n  margin-bottom: 22px;\n}\n\n.rd-section .rd-stat-grid--levels {\n  grid-template-columns: repeat(6, 1fr);\n}\n\n.rd-section .rd-stat-card {\n  background: var(--rd-surface);\n  border: 1px solid var(--rd-border);\n  border-radius: var(--rd-radius);\n  padding: 18px 20px;\n  box-shadow: var(--rd-shadow);\n  min-width: 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.rd-section .rd-stat-card::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, var(--rd-brand), #6b5ce7);\n  opacity: 0.55;\n}\n\n.rd-section .rd-stat-card--earn::after {\n  background: linear-gradient(90deg, var(--rd-success), #4a9e6f);\n}\n\n.rd-section .rd-stat-card__label {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--rd-muted);\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.rd-section .rd-stat-card__value {\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1.2;\n  color: var(--rd-text);\n  word-break: break-word;\n}\n\n.rd-section .rd-stat-card--earn .rd-stat-card__value {\n  color: var(--rd-success);\n}\n\n.rd-section .rd-stat-card__hint {\n  font-size: 12px;\n  color: #8b939e;\n  margin-top: 6px;\n}\n\n.rd-section .rd-profile {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background: var(--rd-surface);\n  border: 1px solid var(--rd-border);\n  border-radius: var(--rd-radius);\n  padding: 16px 18px;\n  box-shadow: var(--rd-shadow);\n  margin-bottom: 18px;\n}\n\n.rd-section .rd-avatar {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--rd-brand), #6b5ce7);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  flex-shrink: 0;\n}\n\n.rd-section .rd-profile__name {\n  font-size: 20px;\n  font-weight: 700;\n  margin: 0 0 6px;\n  color: var(--rd-text);\n}\n\n.rd-section .rd-profile__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  color: var(--rd-muted);\n  font-size: 13px;\n}\n\n.rd-section .rd-back {\n  border-radius: 50px !important;\n  padding: 6px 16px !important;\n  white-space: nowrap;\n}\n\n.rd-section .rd-panel {\n  background: var(--rd-surface);\n  border: 1px solid var(--rd-border);\n  border-radius: var(--rd-radius);\n  box-shadow: var(--rd-shadow);\n  overflow: hidden;\n  margin-bottom: 12px;\n}\n\n.rd-section .rd-inner-tabs {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n  padding: 8px 16px 0;\n  border-bottom: 1px solid var(--rd-border);\n  background: #f8f9fb;\n}\n\n.rd-section .rd-inner-tab {\n  border: 0;\n  background: transparent;\n  padding: 12px 14px;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  color: var(--rd-muted);\n  font-size: 14px;\n}\n\n.rd-section .rd-inner-tab.active {\n  border-bottom-color: var(--rd-brand);\n  color: var(--rd-brand);\n  font-weight: 600;\n}\n\n.rd-section .rd-tab-count {\n  display: inline-flex;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  margin-left: 6px;\n  border-radius: 50px;\n  background: rgba(30, 86, 245, 0.1);\n  color: var(--rd-brand);\n  font-size: 11px;\n  font-weight: 700;\n  align-items: center;\n  justify-content: center;\n}\n\n.rd-section .rd-panel-body {\n  padding: 18px 20px 22px;\n  min-height: 220px;\n}\n\n.rd-section .rd-empty {\n  text-align: center;\n  padding: 36px 16px;\n  color: var(--rd-muted);\n}\n\n.rd-section .rd-empty p {\n  margin: 12px 0 0;\n}\n\n.rd-section .rd-package-card {\n  border: 1px solid var(--rd-border);\n  border-radius: 14px;\n  padding: 16px;\n  margin-bottom: 12px;\n  background: #fbfcfe;\n}\n\n.rd-section .rd-package-head {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.rd-section .rd-kv {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px 16px;\n  font-size: 13px;\n}\n\n.rd-section .rd-kv span {\n  color: var(--rd-muted);\n  display: block;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 2px;\n}\n\n.rd-section .rd-badge {\n  display: inline-block;\n  padding: 3px 9px;\n  border-radius: 50px;\n  font-size: 12px;\n  font-weight: 600;\n  background: rgba(30, 86, 245, 0.1);\n  color: var(--rd-brand);\n}\n\n.rd-section .rd-badge.buy {\n  background: rgba(94, 186, 137, 0.16);\n  color: var(--rd-success);\n}\n\n.rd-section .rd-badge.sell {\n  background: rgba(220, 53, 69, 0.12);\n  color: #dc3545;\n}\n\n.rd-section .rd-table-wrap {\n  overflow-x: auto;\n}\n\n.rd-section .rd-table-wrap table {\n  width: 100%;\n}\n\n.rd-section .rd-table-wrap table th {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--rd-muted);\n  border-bottom: 1px solid var(--rd-border);\n  padding: 10px 8px;\n  font-weight: 600;\n}\n\n.rd-section .rd-table-wrap table td {\n  padding: 12px 8px;\n  border-bottom: 1px solid var(--rd-border);\n  font-size: 13px;\n  vertical-align: middle;\n}\n\nbody:not(.light_theme) .rd-section,\nbody.dark_theme .rd-section {\n  --rd-surface: #1e242c;\n  --rd-border: rgba(255, 255, 255, 0.1);\n  --rd-text: #f2f4f6;\n  --rd-muted: #949aa4;\n  --rd-shadow: 0 8px 28px rgba(0, 0, 0, 0.2);\n}\n\nbody:not(.light_theme) .rd-section .rd-chip,\nbody.dark_theme .rd-section .rd-chip {\n  background: transparent;\n  border-color: rgba(255, 255, 255, 0.15);\n}\n\nbody:not(.light_theme) .rd-section .rd-chip.active,\nbody.dark_theme .rd-section .rd-chip.active {\n  background: var(--rd-brand);\n  border-color: var(--rd-brand);\n}\n\nbody:not(.light_theme) .rd-section .rd-inner-tabs,\nbody.dark_theme .rd-section .rd-inner-tabs {\n  background: rgba(255, 255, 255, 0.03);\n}\n\nbody:not(.light_theme) .rd-section .rd-package-card,\nbody.dark_theme .rd-section .rd-package-card {\n  background: rgba(255, 255, 255, 0.03);\n}\n\n@media (max-width: 1100px) {\n  .rd-section .rd-stat-grid--levels {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 767px) {\n  .rd-section .rd-stat-grid,\n  .rd-section .rd-stat-grid--levels,\n  .rd-section .rd-kv {\n    grid-template-columns: 1fr;\n  }\n\n  .rd-section .rd-profile {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
